import React, { useEffect, useState } from 'react';
import {
  Modal,
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  MenuItem,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DIALOG_BOX_STYLE } from '../../../../_constants/styleConst';

type SelectedSection = {
  key: string;
  name: string;
};

type SelectSelectionModalProps = {
  isOpen: boolean;
  sectionMap: Map<string, string[]>;
  onClose: (excludeSections: string[]) => void;
};

const SelectSelectionModal: React.FC<SelectSelectionModalProps> = ({
  isOpen,
  sectionMap,
  onClose,
}) => {
  const { t } = useTranslation();
  const [selectedSections, setSelectedSections] = useState<SelectedSection[]>(
    [],
  );

  useEffect(() => {
    if (sectionMap.size > 0) {
      setSelectedSections(
        Array.from(sectionMap).map(([key, nameList]) => {
          return { key, name: nameList[0] };
        }),
      );
    }
  }, [sectionMap]);

  const onChangeSection = (key: string, sectionName: string) => {
    setSelectedSections((prev) => {
      return prev.map((section) => {
        if (section.key === key) {
          return {
            key,
            name: sectionName,
          };
        }
        return section;
      });
    });
  };

  const onClickOk = () => {
    // 除外するセクションのMapを作成
    const excludeList: string[] = [];
    for (const [key, nameList] of sectionMap.entries()) {
      selectedSections.forEach((section) => {
        if (section.key === key) {
          nameList.forEach((name) => {
            if (name !== section.name) {
              excludeList.push(name);
            }
          });
        }
      });
    }
    onClose(excludeList);
  };

  return (
    <Modal
      open={isOpen}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={DIALOG_BOX_STYLE}>
        <Typography id="modal-title" variant="h6" component="h2">
          {t('MSG_SELECT_SECTION')}
        </Typography>
        <Typography id="modal-body" variant="h6" component="h3">
          <Grid container spacing={2}>
            <Grid></Grid>
            {Array.from(sectionMap).map(([key, nameList], sectionIndex) => {
              return (
                <Grid size={12} key={`section_${sectionIndex}`}>
                  <Grid size={6} textAlign={'left'}>
                    {key}
                  </Grid>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    defaultValue={nameList[0]}
                  >
                    {nameList.map((sectionName, itemIndex) => {
                      return (
                        <MenuItem
                          key={`section_item_${itemIndex}`}
                          value={sectionName}
                          onClick={() => onChangeSection(key, sectionName)}
                        >
                          {sectionName}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
              );
            })}
            <Box mt={1.5} display="flex" justifyContent="end" width="100%">
              <Button
                onClick={onClickOk}
                variant="contained"
                sx={{ width: '40%' }}
              >
                {t('BTN_OK')}
              </Button>
            </Box>
          </Grid>
        </Typography>
      </Box>
    </Modal>
  );
};

export default SelectSelectionModal;
